<!-- 文件详情页 -->
<template>
  <div class="down_photo" :class="{ down_ppt: fileDetail.FileType == 4 }">
    <!--left  -->
    <div class="down_left">
      <div class="down_imgs">
        <img :src="file.DetailImg" class="down_img" />
      </div>
      <!--采集  -->
      <a class="down_collect" @click="showCollect(file.Id, 1)">
        <i class="icon_add"></i>收藏
      </a>
      <!--botton  -->
      <div class="clearfix down_botton">
        <!--left  -->
        <div class="fl down_user">
          <router-link
            tag="div"
            :to="
              file.UserId != userId
                ? '/personInfo/original?uid=' + file.UserId
                : '/homepage'
            "
          >
            <!--头像  -->
            <img :src="file.Avatar" class="fl mr15 user_head" />
            <span>{{ file.JobNo }}</span>
            <span>{{ file.UserName }}</span>
          </router-link>
        </div>
        <!--right  -->
        <div class="fr down_box">
          <!--评论点赞  -->
          <div class="down_comment">
            <button class="comment_btn" @click="scrollTo">
              <i class="icon_comment"></i>评论
              <span>{{ file.WordsNumbers }}</span>
            </button>
            <button
              class="thumbs_btn"
              :class="[hasLike ? 'thumbsed' : '']"
              @click="thumbsClick"
            >
              <i class="icon_thumbs"></i>点赞
              <span>{{ file.LikeNumbers }}</span>
            </button>
          </div>
          <!--下载  -->
          <!-- <div class="down_num" v-show="file.FileDetailPageShow==2">
            <i class="icon_down"></i>
            <span class="cccc">{{file.DownloadNumbers}}</span>
          </div> -->
        </div>
      </div>
    </div>
    <!--right  -->
    <div class="down_right">
      <!--top  -->
      <div class="right_top">
        <!--通用  -->
        <div class="down_con">
          <div v-if="file.HasUseFile">
            <a @click="fileDown(1)"
              >使用文件下载{{ "（" + fileDetail.FileFormat + "）" }}</a
            >
            <a @click="fileDown(2)" v-if="file.HasStandardFile"
              >使用规范文件{{ "（" + file.UseStandardFileExt + "）" }}</a
            >
            <a @click="fileDown(3)" v-if="file.HasOutputFile"
              >输出文件下载{{ "（" + file.OutputFileExt + "）" }}</a
            >
          </div>
          <div v-else>
            <a @click="fileDown(1)"
              >下载文件{{ "（" + fileDetail.FileFormat + "）" }}</a
            >
          </div>
          <!-- <a>使用规范下载（PDF文件）</a>
              <a>输出文件下载（AI文件）</a> -->
        </div>
      </div>
      <!--bottom  -->
      <div class="right_botton">
        <!-- 图片标题 -->
        <div class="file_del">
          <h2 class="title">图片标题</h2>
          <p>{{ file.Title }}</p>
          <p>
            <span v-show="file.FirstCategory"
              >{{ file.FirstCategory }}>
              <router-link
                tag="a"
                class="link"
                :to="
                  file.SecondLink +
                    '?FileClassify=1&RootId=' +
                    file.FirstCategoryId +
                    '&InteralDirId=' +
                    file.SecondCategoryId
                "
                >{{ file.SecondCategory }}</router-link
              >
            </span>
          </p>
        </div>
        <!-- 基本信息 -->
        <div class="file_del">
          <h2 class="title">基本信息</h2>
          <p v-show="file.FileNo">ID：{{ file.FileNo }}</p>
          <p v-show="fileDetail.Size">尺寸：{{ fileDetail.Size }}px</p>
          <p v-show="fileDetail.StorageSize">
            存储大小：{{ fileDetail.StorageSize }}
          </p>
          <p v-show="file.UpdateTime">更新时间：{{ file.UpdateTime }}</p>
        </div>
        <!--  版权信息-->
        <div
          class="file_del"
          v-show="
            file.CopyrightAll || file.CopyrightSource || file.CopyrightLimit
          "
        >
          <h2 class="title">版权信息</h2>
          <p v-show="file.CopyrightAll">版权所有：{{ file.CopyrightAll }}</p>
          <p v-show="file.CopyrightSource">
            版权来源：{{ file.CopyrightSource }}
          </p>
          <div style="position:relative;">
            <p
              v-show="file.CopyrightLimit"
              class="powerMessage"
              ref="powerMessage"
              @mouseenter="posPowerMessage"
            >
              版权限制：{{ file.CopyrightLimit }}
            </p>
            <div class="messageBox" :style="messageBoxStyle">
              *商业用途图片：指被允许在商业/广告中使用。<br />
              *编辑用途图片：指被允许在新闻报道、出版发行、官方微博、微信等行为中使用，华强方特图库网及其供稿人仅拥有该图片的版权，不拥有画面内容中所涉及的任何人物的肖像权或实物的物权、知识产权等其它权利。该图片仅限编辑报道用途，禁止用于一切商业推广用途。
            </div>
          </div>
        </div>
        <!--标签  -->
        <div class="file_del">
          <h2
            class="title"
            v-show="file.Labels !== undefined && file.Labels.length > 0"
          >
            标签
          </h2>
          <p>
            <span v-for="(item, index) in file.Labels" :key="index">
              <router-link
                tag="a"
                class="label"
                :to="
                  '/searchResList?TitleName=' +
                    item.Name +
                    '&InteralDirId=' +
                    file.SecondCategoryId
                "
                >{{ item.Name }}</router-link
              >
            </span>
          </p>
        </div>
      </div>
    </div>
    <!--采集  -->
    <collect
      :isDialogShow="isCollectShow"
      :fileCoverImg="fileCoverImg"
      @closeCollectDialog="closeCollect"
      :fileId="fileNo"
      :userId="userId"
      :sourceType="1"
    ></collect>
    <!-- 登录 -->
    <login :isShow="logShow" :bgShow="false" @close="logClose"></login>
  </div>
</template>

<script>
import { getToken } from "@/assets/js/modules/auth";
import collect from "../common/collect";
import { getFileDel } from "../../assets/js/modules/fileApi";
import {
  getThumbsDel,
  CancelLike,
  downFileFirst,
  downFileSecond
} from "../../assets/js/modules/articleApi";
import login from "../common/login";
import { debug } from "util";
import { setTimeout } from "timers";
export default {
  props: {
    fileNo: {
      //文章id
    }
  },
  components: {
    collect,
    login
  },
  data() {
    return {
      hasLike: false, //是否点赞
      fileComprehensiveId: null,
      isCollectShow: false, //是否显示收藏
      fileCoverImg: "",
      collectType: "",
      userInfo: "",
      userId: "",
      file: "",
      fileDetail: "",
      fileSize: "",
      fileStorageSize: "",
      // fileDown: [],
      logShow: false,
      url: "",
      MediumCategoryId: "",
      FileDetailPageShow: "",
      messageBoxStyle: ""
    };
  },
  created() {
    this.getUserInfo();
  },
  mounted() {
    //监听版权限制说明的位置信息
    if (this.$refs["powerMessage"]) {
      this.posPowerMessage();
      window.addEventListener("scroll", this.posPowerMessage);
      window.addEventListener("resize", this.posPowerMessage);
    }
    let data = {
      FileNo: this.fileNo
      // UserId: this.userId,
    };
    getFileDel(data).then(res => {
      //获取文件详情
      if (res.data.Success) {
        this.file = res.data.Data;
        this.fileDetail = res.data.Data.FileDetails;
        this.fileComprehensiveId = res.data.Data.FileComprehensiveId;
        this.MediumCategoryId = res.data.Data.MediumCategoryId;
        this.$emit("mcId", this.MediumCategoryId);
        this.hasLike = res.data.Data.HasLike;
        // this.fileDetail.forEach((item, index) => {
        //   if (item.FileDetailType == 1) {
        //     this.fileSize = item.Size;
        //     this.fileStorageSize = item.StorageSize;
        //   }
        // })
        // if (getToken()){
        //   this.hasLike = res.data.Data.HasLike;
        // } else {
        //   this.hasLike = false;
        // }
        this.$emit("filesType", this.fileDetail.FileType);
        //console.log(this.file.FileDetailPageShow);
        if (this.file.FileDetailPageShow != 3 && !getToken()) {
          this.$router.push({
            path: `/login?redirect=${this.$route.fullPath}`
          });
        }
      }
    });
  },
  methods: {
    posPowerMessage() {
      if (this.$refs["powerMessage"]) {
        this.messageBoxStyle = `left:${this.$refs[
          "powerMessage"
        ].getBoundingClientRect().left + "px"};top:${this.$refs[
          "powerMessage"
        ].getBoundingClientRect().top +
          30 +
          "px"};`;
        console.log(this.messageBoxStyle);
      }
    },
    getUserInfo() {
      //用户信息
      if (JSON.parse(localStorage.getItem("userInfo"))) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.userId = this.userInfo.Id;
      } else {
        this.userId = "";
      }
    },
    thumbsClick() {
      //post点赞
      if (getToken()) {
        this.logShow = false;
        if (!this.hasLike) {
          this.file.LikeNumbers++;
          let data = {
            //获取点赞数参数
            SourceID: this.fileNo, //文章ID
            UserID: this.userId, //用户ID
            SourceType: 1, //综合类型(1：文件、2：文章、3：评论)
            Type: 1 //类型(1、点赞、2、收藏、3、下载、4：浏览数)
          };
          getThumbsDel(data).then(res => {
            this.hasLike = !this.hasLike;
            this.fileComprehensiveId = res.data.Data.Id;
            console.log("点赞");
          });
        } else {
          this.file.LikeNumbers--;
          var data = {
            FileComprehensiveId: this.fileComprehensiveId,
            UserId: this.userId
          };
          CancelLike(data).then(res => {
            this.hasLike = !this.hasLike;
            console.log("取消点赞");
          });
        }
      } else {
        this.logShow = true;
      }
    },
    scrollTo() {
      //滚动到指定位置
      document.documentElement.scrollTop = 200;
    },
    showCollect(id, type) {
      //是否显示收藏
      this.collectType = type;
      this.fileId = id;
      this.isCollectShow = true;
      this.fileCoverImg = this.file.DetailImg;
    },
    closeCollect(data) {
      //关闭收藏
      this.isCollectShow = false;
    },
    logClose() {
      this.logShow = false;
    },
    fileDown(FileDetailType) {
      //下载源文件
      let down = {
        FileId: this.file.Id,
        FileDetailType: FileDetailType //（1使用文件  2使用规范文件  3输出文件  4授权文件  5设计交流源文件)
      };
      downFileFirst(down).then(res => {
        if (res.data.Code == 1) {
          let url =
            process.env.BASE_API +
            "/api/UpLoadFile/DownloadSecondAsync?Identity=" +
            res.data.Data;
          window.location.href = url;
        } else {
          this.$warn({
            warnText: '您的账户没有权限，熊出没相关资料需24级以上账户方可下载',
            isShow: true
          });
        }
      });
    }
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

.mr15 {
  margin-right: 15px;
}

.mr8 {
  margin-right: 8px;
}

.cccc {
  color: #ccc;
}

.down_photo {
  width: 100%;
  max-width: 1280px;
  height: 614px;
  margin: 50px auto 24px;
  display: flex;
  justify-content: space-between;
}

.down_photo.down_ppt {
  height: auto;
}
.down_imgs {
  display: flex;
  min-height: 500px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.down_ppt .down_img {
  max-height: 100%;
}

.down_img.no_botton {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.down_left {
  width: 802px;
  height: 100%;
  padding: 32px;
  background: #fff;
  border: 1px solid #e7e7e7;
  position: relative;
  border-radius: 8px;
}

.down_img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  max-height: 500px;
}

.down_vi .down_img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.down_collect {
  position: absolute;
  top: 42px;
  left: 42px;
  color: #fff;
  font-size: 12px;
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: #ff5a5a;
  text-align: center;
  border-radius: 50px;
  cursor: pointer;
}

.icon_add {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: url("../../assets/img/icon_add.png");
  margin-right: 4px;
}

.down_botton {
  margin-top: 18px;
  font-size: 12px;
  line-height: 35px;
  /* position: absolute;
  bottom: 38px;
  width: 91%; */
}

.down_user {
  color: #666;
  cursor: pointer;
}

.user_head {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}

.icon_down {
  width: 17px;
  height: 15px;
  display: inline-block;
  background: url("../../assets/img/icon_down.png");
}

.down_comment button {
  width: 88px;
  height: 26px;
  color: #999;
  background: #fff;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  cursor: pointer;
}

.down_comment button:hover {
  color: #666;
}

.comment_btn {
  margin-right: 12px;
}

.comment_btn:hover .icon_comment {
  background: url("../../assets/img/icon_comments.png");
}

.icon_comment {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_comment.png");
  position: relative;
  top: 3px;
  margin-right: 6px;
}

.thumbs_btn:hover .icon_thumbs {
  background: url("../../assets/img/icon_thumbss.png");
}

.thumbsed .icon_thumbs {
  background: url("../../assets/img/icon_thumbss.png");
}

.icon_thumbs {
  width: 16px;
  height: 16px;
  display: inline-block;
  background: url("../../assets/img/icon_thumbs.png");
  position: relative;
  top: 3px;
  margin-right: 6px;
}

.down_right {
  width: 452px;
  height: 100%;
  padding: 28px;
  background: #fff;
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  /* position: relative; */
  display: flex;
  flex-direction: column;
}

.right_top {
  /* margin-top:28px ; */
}

.down_con a {
  display: block;
  width: 270px;
  height: 42px;
  line-height: 42px;
  border: 1px solid #ff9a35;
  color: #999;
  border-radius: 50px;
  margin: 0 auto 10px;
  text-align: center;
  cursor: pointer;
}

.down_con a:hover {
  background: #ff9a35;
  color: #fff;
}

.right_botton {
  /* width: 87%;
  height:406px; */
  overflow: auto;
  /* position: absolute;
  bottom: 30px; */
}

.right_botton::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0px 20px 20px 13px rgb(243, 243, 243);
  background-color: #ccc;
}

/* 滚动条的滑轨背景颜色 */

.right_botton::-webkit-scrollbar {
  width: 10px;
  background-color: #ccc;
}

.right_botton::-webkit-scrollbar-thumb {
  background-color: #e1e1e1;
}

/* 滑块颜色 */

.file_del .title {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #e7e7e7;
  margin-top: 22px;
}

.file_del p {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
}

.file_del .label {
  display: inline-block;
  /* width: 72px; */
  padding: 0 10px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border: 1px solid #e7e7e7;
  margin-right: 10px;
  margin-bottom: 10px;
}

.file_del .label:hover {
  background: #d9d9d9;
}

.file_del .link {
  text-decoration: underline;
}

.file_del .link:hover {
  color: #ff5a5a;
}
.powerMessage {
  cursor: pointer;
}
.messageBox {
  display: none;
  transition: width 0.5s;
  background: #fff;
  border: 1px solid #e7e7e7;
  position: fixed;
  top: 10px;
  padding: 16px;
  font-size: 14px;
  width: 300px;
  opacity: 0;
}
.powerMessage:hover {
  color: #6aa9ff;
}
.powerMessage:hover + .messageBox {
  display: block !important;
  opacity: 1;
}
.messageBox:hover {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/common/downPhoto.vue